import React, { useState } from 'react';
import { useSubscription } from '../../hooks/useSubscription';
import { AlertTriangle, Clock, CreditCard, X } from 'lucide-react';

const SubscriptionBanner: React.FC = () => {
  const { subscription, isExpired, daysRemaining, getSubscriptionMessage } = useSubscription();
  const [isDismissed, setIsDismissed] = useState(false);

  const message = getSubscriptionMessage();

  // Ne pas afficher si pas de message ou si dismissé
  if (!message || isDismissed) {
    return null;
  }

  // Déterminer le style basé sur le statut
  const getBannerStyle = () => {
    if (isExpired) {
      return {
        bg: 'bg-red-50 border-red-200',
        text: 'text-red-800',
        icon: AlertTriangle,
        iconColor: 'text-red-600'
      };
    }
    
    if (subscription?.subscriptionStatus === 'trial') {
      if (daysRemaining !== null && daysRemaining !== undefined && daysRemaining <= 3) {
        return {
          bg: 'bg-gray-50 border-gray-200',
          text: 'text-gray-800',
          icon: Clock,
          iconColor: 'text-gray-900'
        };
      }
      return {
        bg: 'bg-blue-50 border-blue-200',
        text: 'text-blue-800',
        icon: Clock,
        iconColor: 'text-blue-600'
      };
    }

    return {
      bg: 'bg-yellow-50 border-yellow-200',
      text: 'text-yellow-800',
      icon: AlertTriangle,
      iconColor: 'text-yellow-600'
    };
  };

  const style = getBannerStyle();
  const Icon = style.icon;

  return (
    <div className={`border-b ${style.bg} border-t-0`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-3">
          <div className="flex items-center">
            <Icon className={`w-5 h-5 ${style.iconColor} mr-3 flex-shrink-0`} />
            <p className={`text-sm font-medium ${style.text}`}>
              {message}
            </p>
          </div>
          
          <div className="flex items-center space-x-3">
            {(isExpired || (daysRemaining !== null && daysRemaining !== undefined && daysRemaining <= 7)) && (
              <a
                href="/subscription"
                className="inline-flex items-center px-3 py-1 bg-gray-900 rounded-md text-sm font-medium text-white hover:bg-gray-800 transition-colors border"
              >
                <CreditCard className="w-4 h-4 mr-1" />
                {isExpired ? 'Renouveler' : 'Mon abonnement'}
              </a>
            )}
            
            <button
              onClick={() => setIsDismissed(true)}
              className={`${style.text} hover:opacity-75 transition-opacity`}
              title="Masquer ce message"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionBanner;

export {}; // Fix pour TypeScript isolatedModules
